import React from 'react';
import { Body, Headline } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { api } from '@api';
import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';
import { t } from '@stores/localization';

import { TitleDescriptionIncidentForm } from '../../components/TitleDescriptionIncidentForm';

interface BuildingDefectCommonFormProps extends ParsedEntry<IWidget> {
  subClassification: IncidentSubClassification;
}

export const BuildingDefectCommonForm = observer(
  ({
    subClassification,
    customTranslations,
  }: BuildingDefectCommonFormProps) => {
    return (
      <TitleDescriptionIncidentForm
        incidentKind="BuildingDefectCommon"
        classifications={{
          classification: IncidentClassification.DEFECT_REPORT_PUBLIC,
          subClassification,
        }}
        postIncident={api.incidents.postGenericDefectIncident}
        translations={customTranslations}
        withFileUpload
        preContent={
          <div className="flex flex-col gap-3">
            <Headline level={3}>{t('defectFormDescriptionTitle')}</Headline>

            <Body>{t('defectFormDescriptionBody')}</Body>
          </div>
        }
      />
    );
  }
);
